import { RenderGlobalNavOrUndefined } from '@eventbrite/global-nav';
import { gettext } from '@eventbrite/i18n';
import { connect } from 'react-redux';

const mapStateToProps = (state: any) => ({
    isUsingCurrentLocation: state.location.isUsingCurrentLocation,
    location: state.location,
});

const ConnectedGlobalNavHeader = (props: any) => {
    const { search_data, env, user, isUsingCurrentLocation, location } = props;

    const SEARCH_EVENTS = gettext('Search events');
    const SEARCH = gettext('Search');

    const searchQuery = search_data?.event_search?.q || '';
    const desktopLabel = searchQuery || SEARCH_EVENTS;
    const mobileLabel = searchQuery || SEARCH;
    const isSearchPage = props.current_page === 'search';

    const searchBar = {
        renderSearchBar: isSearchPage,
        desktopLabel,
        mobileLabel,
        location,
        isUsingCurrentLocation: isUsingCurrentLocation,
    };

    const GlobalNavHeader = RenderGlobalNavOrUndefined({
        config: {
            env,
            user,
            searchBar: searchBar,
        },
    });

    return GlobalNavHeader ?? null;
};

export default connect(mapStateToProps)(ConnectedGlobalNavHeader);
